/* eslint-disable @typescript-eslint/no-explicit-any */

import type { Client, RequestContext } from "../client";
import type { RunbookResource, ProgressionResource, ProjectResource, ResourceCollection, RunbookProgressionResource, RunbooksDashboardItemResource } from "../resources";
import type { ListArgs } from "./basicRepository";

export type GetTaskRunDashboardItemsListArgs = {
    projectIds?: string[];
    runbookIds?: string[];
    environmentIds?: string[];
    tenantIds?: string[];
    taskIds?: string[];
} & ListArgs;

export class ProgressionRepository {
    private client: Client;
    constructor(
        client: Client,
        private readonly requestContext: RequestContext
    ) {
        this.client = client;
    }
    getProgression(project: ProjectResource, options?: any): Promise<ProgressionResource> {
        return this.client.get<ProgressionResource>(this.requestContext, project.Links["Progression"], options);
    }
    getRunbookProgression(runbook: RunbookResource, options?: any): Promise<RunbookProgressionResource> {
        return this.client.get<RunbookProgressionResource>(this.requestContext, runbook.Links["Progression"], options);
    }
    getTaskRunDashboardItemsForRunbook(runbook: RunbookResource, options?: GetTaskRunDashboardItemsListArgs): Promise<ResourceCollection<RunbooksDashboardItemResource>> {
        return this.client.get<ResourceCollection<RunbooksDashboardItemResource>>(this.requestContext, runbook.Links["TaskRunDashboardItemsTemplate"], options);
    }
    getTaskRunDashboardItemsForProject(project: ProjectResource, options?: GetTaskRunDashboardItemsListArgs): Promise<ResourceCollection<RunbooksDashboardItemResource>> {
        return this.client.get<ResourceCollection<RunbooksDashboardItemResource>>(this.requestContext, project.Links["RunbookTaskRunDashboardItemsTemplate"], options);
    }
}
